/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BinaryFileType } from '../../models/binary-file-type';
import { KeyType } from '../../models/key-type';
import { Token64LengthType } from '../../models/token-64-length-type';

export interface GetConsigneeSignatureFromSignaturePad$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
  checkinKey: KeyType;
  token: Token64LengthType;
}

export function getConsigneeSignatureFromSignaturePad(http: HttpClient, rootUrl: string, params: GetConsigneeSignatureFromSignaturePad$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeSignatureFromSignaturePad.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('checkinKey', params.checkinKey, {});
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/png', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BinaryFileType>;
    })
  );
}

getConsigneeSignatureFromSignaturePad.PATH = '/organization-sites/{organizationSiteKey}/consignee/checkins/{checkinKey}/signature-pads/signature';
